import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './VerifyEmailBindPage.css';

interface VerifyResponse {
  success: true;
  data: {
    verified: true;
    message: string;
  };
}

interface ErrorResponse {
  success: false;
  error?: string;
}

const VerifyEmailBindPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('驗證連結無效，請重新申請綁定。');
        return;
      }

      try {
        const API_BASE = import.meta.env.VITE_API_URL || '';
        const response = await fetch(`${API_BASE}/api/verify-email/bind?token=${token}`, {
          method: 'GET',
        });

        const result: VerifyResponse | ErrorResponse = await response.json();

        if (response.ok && (result as VerifyResponse).success) {
          setStatus('success');
          setMessage((result as VerifyResponse).data.message);
          // Redirect to member center after 3 seconds
          setTimeout(() => {
            navigate('/member');
          }, 3000);
        } else {
          setStatus('error');
          setMessage((result as ErrorResponse).error || '驗證失敗，請重新申請綁定。');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
        setMessage('網路錯誤，請稍後再試。');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verify-email-page">
      <div className="verify-email-card">
        {status === 'loading' && (
          <>
            <div className="verify-email-icon loading">
              <div className="spinner"></div>
            </div>
            <h2>驗證中...</h2>
            <p>正在驗證您的 Email，請稍候。</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="verify-email-icon success">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#22c55e" fillOpacity="0.2"/>
                <path d="M8 12L11 15L16 9" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>驗證成功！</h2>
            <p>{message}</p>
            <p className="verify-email-redirect">將在 3 秒後跳轉至會員中心...</p>
            <button
              className="btn-primary"
              onClick={() => navigate('/member')}
            >
              前往會員中心
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="verify-email-icon error">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#ef4444" fillOpacity="0.2"/>
                <path d="M15 9L9 15M9 9L15 15" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <h2>驗證失敗</h2>
            <p>{message}</p>
            <div className="verify-email-actions">
              <button
                className="btn-secondary"
                onClick={() => navigate('/member/settings')}
              >
                前往會員中心
              </button>
              <button
                className="btn-primary"
                onClick={() => navigate('/')}
              >
                返回首頁
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailBindPage;
